import React, { Component, FormEvent, MouseEvent } from "react";
import StringFacet from "./string_facet";
import NumericRangeFacet from "./numeric_range_facet";
import { SearchResponse } from "../../rpc/admin/search_pb";
import Adapter from "./adapter";

const FACET_CHUNK_SIZE = 10;

interface FacetsProps {
    adapter: Adapter;
    facet: SearchResponse.Aggregation;
}

interface FacetsState {
    query: string;
    showing: number;
}

class Facets extends Component<FacetsProps, FacetsState> {

    constructor(props: FacetsProps) {
        super(props);
        this.state = {
            query: '',
            showing: FACET_CHUNK_SIZE,
        };
    }

    handleQueryChange = (e: FormEvent<HTMLInputElement>) => {
        this.setState({ query: e.currentTarget.value });
    };

    handleMore = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        this.setState({
            showing: this.state.showing + FACET_CHUNK_SIZE,
        });
    }

    handleLess = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        this.setState({
            showing: this.state.showing - FACET_CHUNK_SIZE,
        });
    }

    private collapseQuery(q: string): string {
        q = q.toLowerCase();
        let result = '';
        for (let i = 0; i < q.length; i++) {
            const code = q.charCodeAt(i);
            if ((code > 47 && code < 58) || (code > 96 && code < 123)) {
                result = result + q[i];
            }
        }
        return result;
    }

    render() {
        let facets: SearchResponse.Aggregation.Value[] = [];

        let more: JSX.Element | null = null, less: JSX.Element | null = null, footer: JSX.Element | null = null;

        const query = this.collapseQuery(this.state.query);
        if (query) {
            this.props.facet!.getAggregationsList().forEach((facet) => {
                if (facet.getStringAggregation() && this.collapseQuery(facet.getStringAggregation()!.getLabel()).indexOf(query) >= 0) {
                    facets.push(facet);
                } else if (facet.getRangeAggregation() && this.collapseQuery(facet.getRangeAggregation()!.getLabel()).indexOf(query) >= 0) {
                    facets.push(facet);
                }
            });
        } else {
            if (this.props.facet!.getAggregationsList().length > this.state.showing) {
                more = <button type="button" onClick={this.handleMore}>+ More</button>;
            }
            if (this.state.showing > FACET_CHUNK_SIZE) {
                less = <button type="button" onClick={this.handleLess}>- Less</button>;
            }
            if (more || less) {
                footer = (<div className="search-facets-footer">
                    {
                        more && more
                    }
                    {
                        less && less
                    }
                </div>);
            }
            facets = this.props.facet!.getAggregationsList().slice(0, this.state.showing);
        }

        let input: JSX.Element | null = null;
        if (this.props.facet!.getAggregationsList().length > FACET_CHUNK_SIZE * 2) {
            input = <input type="search"
                className="input is-small"
                onChange={this.handleQueryChange}
                placeholder={"Filter " + this.props.facet!.getLabel()} />;
        }

        let index = 0;
        return (
            <div className="search-facets">
                <h2>{this.props.facet!.getLabel()}</h2>
                {
                    input && input
                }
                {
                    facets.map((facet) => {
                        if (facet.getStringAggregation()) {
                            return (<StringFacet adapter={this.props.adapter}
                                field={this.props.facet!.getField()}
                                value={facet.getStringAggregation()!}
                                key={'facet-' + (index++)} />);
                        } else if (facet.getRangeAggregation()) {
                            return (<NumericRangeFacet adapter={this.props.adapter}
                                field={this.props.facet!.getField()}
                                value={facet.getRangeAggregation()!}
                                key={'facet-' + (index++)} />);
                        }
                        return (<></>);
                    })
                }
                {
                    footer && footer
                }
            </div>
        );
    }
}

export default Facets;